var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgConfirmationIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 96,
  height: 96,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#F5F5F5",
  d: "M0 0h96v96H0z"
})), _g || (_g = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#confirmation-icon_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-672-469H768V768H-672z"
}), /*#__PURE__*/React.createElement("rect", {
  width: 946,
  height: 876,
  x: -292,
  y: -211,
  fill: "#F5F5F5",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 164,
  height: 183,
  x: -78,
  y: -14,
  fill: "#fff",
  rx: 4
}), /*#__PURE__*/React.createElement("rect", {
  width: 164,
  height: 183,
  x: -78,
  y: -14,
  stroke: "#333",
  rx: 4
}), /*#__PURE__*/React.createElement("circle", {
  cx: 4,
  cy: 59,
  r: 35,
  fill: "#F5F5F5"
}), /*#__PURE__*/React.createElement("rect", {
  width: 15,
  height: 15,
  x: 60.5,
  y: -3.5,
  stroke: "#333",
  rx: 1.5
}), /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M-675-469H768V768H-675z",
  opacity: 0.8
}), /*#__PURE__*/React.createElement("g", {
  filter: "url(#confirmation-icon_svg__b)"
}, /*#__PURE__*/React.createElement("rect", {
  width: 614,
  height: 379,
  x: -259,
  y: -40,
  fill: "#fff",
  rx: 4,
  shapeRendering: "crispEdges"
}), /*#__PURE__*/React.createElement("mask", {
  id: "confirmation-icon_svg__c",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M95.999 48a48 48 0 1 1-96 0 48 48 0 0 1 96 0",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  stroke: "#333",
  d: "M95.999 48a48 48 0 1 1-96 0 48 48 0 0 1 96 0Z",
  clipRule: "evenodd",
  mask: "url(#confirmation-icon_svg__c)"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#333",
  strokeMiterlimit: 10,
  strokeWidth: 1.7,
  d: "M61.684 24.545 37.79 50.212a1.25 1.25 0 0 1-1.828 0l-9.78-10.5"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#772432",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.7,
  d: "M60.083 69.573h-9.998a2.21 2.21 0 0 1-2.044-1.355l-3.354-7.832a2.2 2.2 0 0 1-.156-.814v-2.219a2.22 2.22 0 0 1 2.222-2.222h8.295l-2.346-5.075-.033-.356a1.65 1.65 0 0 1 .485-1.166l1.186-1.178 7.31 7.32a2.17 2.17 0 0 1 .655 1.567V67.35a2.223 2.223 0 0 1-2.222 2.222"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#772432",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 1.7,
  d: "M64.736 69.075h4.443v-13.33h-4.443z"
})))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "confirmation-icon_svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-672-469H768V768H-672z"
})), /*#__PURE__*/React.createElement("filter", {
  id: "confirmation-icon_svg__b",
  width: 622,
  height: 387,
  x: -263,
  y: -42,
  colorInterpolationFilters: "sRGB",
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0,
  result: "BackgroundImageFix"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  in: "SourceAlpha",
  result: "hardAlpha",
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
}), /*#__PURE__*/React.createElement("feOffset", {
  dy: 2
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 2
}), /*#__PURE__*/React.createElement("feComposite", {
  in2: "hardAlpha",
  operator: "out"
}), /*#__PURE__*/React.createElement("feColorMatrix", {
  values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.160784 0 0 0 0.16 0"
}), /*#__PURE__*/React.createElement("feBlend", {
  in2: "BackgroundImageFix",
  result: "effect1_dropShadow_1_24"
}), /*#__PURE__*/React.createElement("feBlend", {
  in: "SourceGraphic",
  in2: "effect1_dropShadow_1_24",
  result: "shape"
})))));
export { SvgConfirmationIcon as ReactComponent };
export default __webpack_public_path__ + "a5a564593201a0857e606ac1320ac5fe.svg";